import React from "react"
import { Breakpoint, useIsDown } from "../../../../../features/layout/hooks"

interface Props {
  children: any
  md?: boolean
  lg?: boolean
}

const breakpoint = (md?: boolean, lg?: boolean): Breakpoint => {
  if (lg) {
    return "md"
  }
  if (md) {
    return "sm"
  }

  return "xs"
}

const DesktopOnlyJs = ({ children, md, lg }: Props) => {
  const isDown = useIsDown(breakpoint(md, lg))
  if (isDown) {
    return <></>
  }
  return <>{children}</>
}

export default DesktopOnlyJs
